import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable({ providedIn: "root" })
export class BankService {
  private subject = new Subject<string>();

  sendBank(bank: string) {
    this.subject.next(bank);
  }
  getBank(): Observable<string> {
    return this.subject.asObservable();
  }
}
